module.exports = __webpack_public_path__ + "media/mg-cobranca.eae6e639.mp4";